"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRuntimeBackendUrl = void 0;
var _getRuntimeUrl = require("../getRuntimeUrl");
var _types = require("../types");
const getRuntimeBackendUrl = urlsConfiguration => {
  const isAKS = typeof window === 'undefined' && process.env.ServiceRuntime === 'K8s';
  const url = (0, _getRuntimeUrl.getRuntimeUrl)(urlsConfiguration, isAKS ? _types.ServiceRuntime.K8s : _types.ServiceRuntime.Public);
  return url;
};
exports.getRuntimeBackendUrl = getRuntimeBackendUrl;
